<template>
  <div
    v-for="(item, i) in props.list"
    :key="i"
    :class="[
      'modeType',
      props.modelValue === item?.data?.goodsId ? 'active' : '',
      props.disableList.includes(item?.data?.goodsId) ? 'disable' : '',
    ]"
    @click="changeModeType(item?.data?.goodsId)"
  >
    {{ item?.data?.moduleName }}
    <sup v-if="item?.data?.moduleLabel" style="font-size: 12px">{{
      item?.data?.moduleLabel
    }}</sup>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: String,
    requeired: true,
  },
  list: {
    type: Array,
    requeired: true,
    default: () => [],
  },
  disableList: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(["update:modelValue"]);

console.log("props.disableList", props.disableList);

const changeModeType = (id) => {
  // if (props.disableList.includes(id)) return; // 必选项不允许修改状态
  emit("update:modelValue", id);
};
</script>

<style lang="less" scoped>
.modeType {
  .fcf(22,#fff,600);
  .lh(80);
  height: 80px;
  background: #444444;
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
  padding: 0 18px;
  .one-line-ellipsis();
}
.modeType + .modeType {
  margin-top: 12px;
}
.active {
  position: relative;
  background-image: url("@/assets/imgs/product/highlight.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  // position: relative;
  // background: linear-gradient(
  //   40deg,
  //   rgba(1, 137, 190, 1),
  //   rgba(50, 163, 149, 1)
  // );
  // border-radius: 10px;
  // padding-left: 18px;
  // .lh(74);
}
// .active:after {
//   content: attr(data-content-name);
//   display: block;
//   position: absolute;
//   top: 3px;
//   left: 3px;
//   right: 3px;
//   bottom: 3px;
//   background: #666666;
//   border-radius: 10px;
//   padding-left: 15px;
// }

.disable {
  background: #222222;
  border-radius: 10px;
  color: #888;
}

@media (max-width: 1024px) {
  .modeType {
    .fcf(14,#fff,600);
  }
}
</style>
